'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cc = require('classcat');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cc__default = /*#__PURE__*/_interopDefaultLegacy(cc);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".react-label_1-1-4_co-label {\n  box-sizing: border-box;\n  font-family: var(--font-family);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  cursor: pointer;\n}\n\n.react-label_1-1-4_co-label.react-label_1-1-4_co-label--warning {\n  color: var(--warning-700);\n}\n.react-label_1-1-4_co-label.react-label_1-1-4_co-label--error {\n  color: var(--error-700);\n}";
var styles = {
  "co-label": "react-label_1-1-4_co-label",
  "co-label--warning": "react-label_1-1-4_co-label--warning",
  "co-label--error": "react-label_1-1-4_co-label--error"
};
styleInject(css);

const getModifierClassName = modifier => modifier ? `co-label--${modifier}` : "";

const Label = ({
  className = "",
  forwardedRef,
  htmlFor,
  type,
  ...props
}) => {
  const classStyles = {
    [styles["co-label"]]: true,
    [styles[getModifierClassName(type)]]: type,
    [className]: !!className
  };
  return /*#__PURE__*/React__default['default'].createElement("label", _extends({
    className: cc__default['default'](classStyles),
    ref: forwardedRef,
    htmlFor: htmlFor
  }, props, {
    "data-co-name": "Label",
    "data-co-version": "1.1.4",
    "data-co-project": "cobalt"
  }));
};

exports.default = Label;
